import {PropsWithChildren, RefObject} from 'react';
import {twMerge} from '../../../common/twMerge';
import {DayOfWeekSectionColumnList} from './DayOfWeekSectionColumnList';
import {DayOfWeekSectionColumnTitle} from './DayOfWeekSectionColumnTitle';

interface Props {
  className?: string;
  columnRef?: RefObject<HTMLDivElement>;
}

export const DayOfWeekSectionColumn = ({
  children,
  className,
  columnRef,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={twMerge('flex flex-col items-start flex-[1_0_0]', className)}
      ref={columnRef}
    >
      {children}
    </div>
  );
};

DayOfWeekSectionColumn.Title = DayOfWeekSectionColumnTitle;
DayOfWeekSectionColumn.List = DayOfWeekSectionColumnList;
